import styled from 'styled-components'

const Container = styled.div<{ flexDirection?: string}>`
  display: flex;
  flex-direction: ${({flexDirection}) => (!!flexDirection && flexDirection === "row" ? "row" : "column")};
  align-items: center;
  justify-content: center;
  flex: 1;

  width: 100%;
  padding: 16px 0;
  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 32px 16px;
  }

  background-position: bottom 24px center;
  background-size: 90%;

  ${({ theme }) => theme.mediaQueries.xs} {
    background-size: auto;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    background-repeat: no-repeat;
    background-position: center 420px, 10% 230px, 90% 230px;
    background-size: contain, 266px, 266px;
    min-height: 90vh;
  }
`

export default Container
